import { createClient } from '@supabase/supabase-js';

// Initialize Supabase with environment variables
const supabaseUrl ='https://czicqdiaprevimlnbtra.supabase.co';
const supabaseKey ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN6aWNxZGlhcHJldmltbG5idHJhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA1ODIyOTYsImV4cCI6MjA3NjE1ODI5Nn0.jhLo-BaZeuHllUesL2EZd9WnZNemk9FsGE2zbR7bHk4"
const supabase = createClient(supabaseUrl, supabaseKey);

export { supabase };
